import axios from 'axios';

export const apiJalles = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 20000,
});

export const urlWebSockt = process.env.REACT_APP_WS_URL || window.location.origin;
